import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import conse from '@/assets/conse.png';
import modalbg from '@/assets/modalbg.png';
import './Modal.css';

const Modal = ({ show, prizeIcon, value, content, onClick, btnName }) => {
    const [isVisible, setIsVisible] = useState(show);
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (show) {
            setIsVisible(true);
            setIsClosing(false);
        } else {
            setIsClosing(true);
            setTimeout(() => setIsVisible(false), 300); // 等待动画结束
        }
    }, [show]);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
                className={`w-[411px] h-[255px] shadow-lg z-50 rounded-lg  modal-body relative ${isClosing ? 'scale-out' : ''}`}
            >
                {!btnName && (
                    <div className="flex justify-center text-white text-xl font-normal mt-8">
                        Congratulations on getting
                    </div>
                )}
                {btnName && (
                    <div className="flex justify-center text-white text-xl font-normal mt-8">
                        Insufficient votes
                    </div>
                )}
                <div className="flex flex-col items-center mt-14 p-1">
                    <p className="text-center text-base text-[#A8A8A8]">{content}</p>
                    {!btnName && (
                        <div
                            className="flex flex-col items-center text-white text-xl"
                            style={{
                                textShadow: '1px 0px 1px 0px rgba(0, 0, 0, 0.78)',
                            }}
                        >
                            <img src={prizeIcon} alt="" className="w-[42.2px] h-[42.2px]" />
                            <div>{value}</div>
                        </div>
                    )}
                </div>
                <img src={conse} alt="" className='absolute right-2 top-2 w-7 h-7 cursor-pointer' onClick={onClick} />
                <img src={modalbg} alt="" className='absolute right-0 bottom-0' />
            </div>
            <div className="fixed inset-0 bg-black opacity-50"></div>
        </div>
    );
};

Modal.propTypes = {
    show: PropTypes.bool.isRequired,
    prizeIcon: PropTypes.string,
    value: PropTypes.number,
    content: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    btnName: PropTypes.string.isRequired,
};

export default Modal;
